import {Avatar, Typography} from "@material-tailwind/react";
import {BsCheckSquare, BsInfoSquare, BsXSquare} from "react-icons/bs";
import persianNumberFormat from "../../../helper/PersianNumberFormat";
import React, {useContext, useState} from "react";
import {getFileUrl} from "../../../config";
import {TableHead} from "../../system/thead";
import {PaginateContext} from "../../../context/paginate";


const TABLE_HEAD = [
  "#",
  "مباشر",
  "پروفایل",
  "کدملی",
  "استان",
  "ثبت نام",
  "وضعیت",
  "آخرین ورود"
];

export function AgentReportGrid({
                                  userReport,
                                }) {
  const avatar = '/assets/blank_profile.jpg';

  const [selectedHead, setSelectedHead] = useState("#")

  const {
    setSortBy,
    sortType,
    setSortType,
  } = useContext(PaginateContext)

  const headMap = {
    "#": "",
    "مباشر": "name",
    "پروفایل": "photo",
    "کدملی": "national_code",
    "استان": "province_title",
    "ثبت نام": "register_time",
    "وضعیت": "status",
    "آخرین ورود": "last_login",
  }

  const headSortable = {
    "#": false,
    "مباشر": true,
    "پروفایل": false,
    "کدملی": true,
    "استان": true,
    "ثبت نام": true,
    "وضعیت": true,
    "آخرین ورود": true,
  }

  return (
    <div>
      <table className="mt-4 text-left w-full">
        <TableHead
          tableHead={TABLE_HEAD}
          headSortable={headSortable}
          headMap={headMap}
          sortType={sortType}
          setSortType={setSortType}
          setSortBy={setSortBy}
          selectedHead={selectedHead}
          setSelectedHead={setSelectedHead}
        />
        <tbody className="textCenter">
        {userReport.map(
          ({
             id,
             name,
             phone,
             photo,
             national_code,
             province_title,
             register_time,
             status,
             last_login
           }, index) => {
            const isLast = index === userReport.length - 1;
            const classes = isLast ? "p-4" : "p-4 border-b border-blue-gray-50";

            return (
              <tr key={id}>

                <td className={classes}>
                  <div className="flex justify-center">
                    <Typography color="blue-gray">
                      {persianNumberFormat(index + 1, true)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex flex-col justify-center px-4">
                    <Typography color="blue-gray">
                      {name}
                    </Typography>
                    <Typography color="blue-gray">
                      {persianNumberFormat(phone)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    {photo.length > 0 &&
                      <Avatar variant="circular" alt="tania andrew"
                              className="cursor-pointer border-white"
                              withBorder={true} size="sm"
                              src={getFileUrl(photo)}
                      />
                    }
                    {photo.length === 0 &&
                      <Avatar variant="circular" alt="tania andrew"
                              className="cursor-pointer border-white"
                              withBorder={true} size="sm"
                              src={avatar}
                      />
                    }
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {persianNumberFormat(national_code)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {province_title}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex flex-col justify-center px-4">
                    <Typography color="blue-gray">
                      {persianNumberFormat(register_time.split(" ")[0])}
                    </Typography>
                    <Typography color="blue-gray">
                      {persianNumberFormat(register_time.split(" ")[1])}
                    </Typography>

                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center ">
                    {
                      status === 'accepted' ? <BsCheckSquare color={"green"} size={30}/> :
                        status === 'new' ? <BsInfoSquare color={"amber"} size={30}/> :
                          <BsXSquare color={"red"} size={30}/>
                    }
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex flex-col justify-center px-4">
                    <Typography color="blue-gray">
                      {persianNumberFormat(last_login.split(" ")[0])}
                    </Typography>
                    <Typography color="blue-gray">
                      {persianNumberFormat(last_login.split(" ")[1])}
                    </Typography>

                  </div>
                </td>

              </tr>
            );
          },
        )}
        </tbody>
      </table>
    </div>
  );
}
